
















import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import ChemicalNotationInput from '@/chemical-equations/components/ChemicalNotationInput.vue';

export default defineComponent({
  name: 'Question561b',
  components: {ChemicalNotationInput},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        balancedEquation: null,
      },
    };
  },
});
